// withNotificationDisplayedTracking.js
'use strict';
import React from 'react';
import PropTypes from 'prop-types';

import trackMixpanel, { EventTypes, getViewId } from '../resource/mixpanel.js';

/**
 * With notification displayed tracking
 * @param {any} notificationTag - param.
 */
const withNotificationDisplayedTracking = BaseComponent => {
  class WithNotificationDisplayedTracking extends React.PureComponent {
    track = () => {
      const {
        notificationId,
        notificationTag,
        oembedType,
        notificationPosition,
        notificationLink,
        notificationExp,
      } = this.props;
      if (!notificationId) {
        return;
      }
      return trackMixpanel({
        type: EventTypes.NOTIFICATION_DISPLAYED,
        payload: {
          id: notificationTag, // use tag for record not object id
          type: oembedType,
          position: notificationPosition,
          link: notificationLink,
          exp: notificationExp,
          viewId: getViewId({
            pathname: window.location.pathname,
          }),
        },
      });
    };
    componentDidMount() {
      this.track();
    }
    componentDidUpdate(prevProps) {
      const { notificationId } = this.props;
      if (notificationId !== prevProps.notificationId) {
        this.track();
      }
    }
    render() {
      return <BaseComponent {...this.props} />;
    }
  }
  WithNotificationDisplayedTracking.propTypes = {
    notificationId: PropTypes.string,
    notificationTag: PropTypes.string,
    oembedType: PropTypes.string,
    notificationPosition: PropTypes.string,
    notificationLink: PropTypes.string,
    notificationExp: PropTypes.number,
  };
  WithNotificationDisplayedTracking.defaultProps = {
    notificationId: null,
    notificationTag: null,
    oembedType: null,
    notificationPosition: null,
    notificationLink: null,
    notificationExp: null,
  };
  return WithNotificationDisplayedTracking;
};

export default withNotificationDisplayedTracking;
